// =============================================================================
// Feature Flags Module
// =============================================================================
import $ from "jquery";

const body = document.querySelector("body");
const flags = [
  { name: "aktuell", value: ["default"], default: true, enabled: true },
  {
    name: "mehr a11y",
    value: ["v-a11y"],
    default: false,
    enabled: true,
  }
];
const excluded =
  "div, span, ul, ol, li, a, p, h1, h2, h3, h4, h5, h6, strong, i, button, input, textarea, select, label, table, tr, td, th, img, svg";

const activateFlags = (session) => {
  const div = document.createElement("div");
  div.classList.add("feature-flag-container");
  flags.forEach((flag) => {
    if (!flag.enabled) return;
    const btn = document.createElement("button");
    btn.dataset.val = flag.value.toString();
    btn.textContent = flag.name;
    // if (flag.default) btn.classList.add("active");
    div.appendChild(btn);
  });
  document.body.appendChild(div);

  if (session) {
    let sessionArray = session.split(",");
    sessionArray.forEach((sess) => {
      body.classList.add(sess);
      $(excluded).addClass(sess);
    });
    document.querySelector(`[data-val="${session}"]`).classList.add("active");
  } else {
    document
      .querySelector(".feature-flag-container button")
      .classList.add("active");
  }

  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.querySelector(".feature-flag-container")) {
      let featureFlagBtns = document.querySelectorAll(
        ".feature-flag-container button"
      );

      featureFlagBtns.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          let featureFlag = this.dataset.val;
          let featureFlags = featureFlag.split(",");

          flags.forEach((flag) => {
            flag.value.forEach((value) => {
              $(`.${value}`).removeClass(value);
            });
          });

          sessionStorage.setItem("featureFlags", featureFlag);
          if (featureFlag && featureFlag !== "default") {
            featureFlags.forEach((fflag) => {
              body.classList.add(fflag);
              $(excluded).addClass(fflag);
            });
          }

          $(".feature-flag-container .active").removeClass("active");
          $(this).addClass("active");
        });
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};

export const init = () => {
  let onBtn = document.getElementById("feature_flags_on");
  let offBtn = document.getElementById("feature_flags_off");

  let session = sessionStorage.getItem("featureFlags");
  if (session) activateFlags(session);

  if (onBtn) {
    onBtn.addEventListener("click", () => {
      sessionStorage.setItem("featureFlags", "default");
      activateFlags();
    });
  }

  if (offBtn) {
    offBtn.addEventListener("click", () => {
      let ffContainer = document.querySelector(".feature-flag-container");
      if (ffContainer) ffContainer.remove();
      sessionStorage.removeItem("featureFlags");
    });
  }
};
